module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/spinner-white-44ce704ffedcd5dd2827b7b27a6582d3.svg";